var WooShop = {
	isMoving:false,
	txt_addToCart:"",
	mouseX:0,
	mouseY:0,
	init:function(){
		
		if(Config.isTouchDevice()){
			$(".rollover-product-container").addClass("mobile");
		}
		/*
		$(window).resize(function(){
			WooShop.resize();
		});
		WooShop.resize();
		*/
		$( ".single_variation_wrap" ).on( "show_variation", function(){

			if(WooShop.txt_addToCart == ""){
				WooShop.txt_addToCart = $(".woocommerce-variation-add-to-cart .single_add_to_cart_button").html();
			}

			var _price_variation =  $(".woocommerce-variation.single_variation").find(".woocommerce-Price-amount").html();

			$(".woocommerce-variation-add-to-cart .single_add_to_cart_button").html(WooShop.txt_addToCart + "<span class='price'>" + _price_variation + "</span>");
		});

		$(".btn-filter").on("click touchend", function(e){
			if(e.type == 'touchend'){
				$(this).off("click");
			}			
			
			$(".shop-top-widget").addClass("open");

			setTimeout(function(){
				$(".shop-top-widget .shadow").on("click touchend", function(e){
					
					$(".shop-top-widget .shadow").off("click touchend");
					$(".shop-top-widget .btn-close").off("click touchend");
					
					$(".shop-top-widget").removeClass("open");
				});
				
				$(".shop-top-widget .btn-close").on("click touchend", function(e){
					
					$(".shop-top-widget .shadow").off("click touchend");
					$(".shop-top-widget .btn-close").off("click touchend");
					
					$(".shop-top-widget").removeClass("open");
				});
				
			}, 100);

		});



		$(window).mousemove(function(event){            
			WooShop.mouseX = event.pageX;
			WooShop.mouseY = event.pageY;
		});

		$(".loop .tease-product").find(".tease--img-container").mouseenter(function(){
			
			$(".rollover-product-container").addClass("visible");

			/*$(this).find("img").css({width:$(this).find("img").attr("hover_w"), height:$(this).find("img").attr("hover_h")});*/
			var attr = $(this).parent().attr('outofstock');
			/*
			if (typeof attr !== 'undefined' && attr !== false) {
				$(".rollover-product-container").addClass("outofstock");
			}else{
				$(".rollover-product-container").removeClass("outofstock");
			}
			*/
			WooShop.isMoving = true;
			WooShop.moveRollover();
		}).mouseleave(function(){
			WooShop.isMoving = false;

			/*$(this).find("img").css({width:$(this).find("img").attr("out_w"), height:$(this).find("img").attr("out_h")});*/
			$(".rollover-product-container").removeClass("visible");
		});
	},
	moveRollover:function(){

		$(".rollover-product-container").css({left:WooShop.mouseX, top:WooShop.mouseY});

		if(WooShop.isMoving == true){
			setTimeout(function(){
				WooShop.moveRollover();
			}, 40);
		}
	},
	resize:function(){
		/*$(".loop .tease-product").each(function(i){
			
			var _cont_w = Math.floor( $(this).find(".tease--img-container").innerWidth());
			var _cont_h = Math.floor( $(this).find(".tease--img-container").innerHeight());

			var _img_w = Math.floor( $(this).find("img").outerWidth());
			var _img_h = Math.floor( $(this).find("img").outerHeight());

			var _ratio = _img_w / _img_h;

			/*   CALCUL TAILLE HOVER   *
			var _img_w_on = _cont_w;
			var _img_h_on = Math.round(_img_w_on / _ratio);

			if(_img_h_on < _cont_h){
				_img_h_on = _cont_h;
				_img_w_on = Math.round(_img_h_on * _ratio);

				$(this).addClass("hauteur");
			}

			/* CALCUL TAILLE OUT  *
			if(_img_w > _cont_w * 0.8){
				/* CALAGE SUR LA LARGEUR *
				_img_w = Math.round(_cont_w * 0.8);
				_img_h = Math.round(_img_w / _ratio);
			}

			if(_img_h > _cont_h * 0.8){
				/* CALAGE SUR LA HAUTEUR *
				_img_h = Math.round(_cont_h * 0.8);
				_img_w = Math.round(_img_h * _ratio);
			}
			$(this).find("img").attr({"hover_w": _img_w_on, "hover_h": _img_h_on, "out_w":_img_w, "out_h":_img_h});			
			$(this).find("img").css({width:_img_w, height:_img_h});
		})
		*/
	},
	load_more:function(){
		$('.products--list').infiniteScroll({
			path: '.next',
			append: '.tease-product',
			hideNav: '.woocommerce-pagination',
			button: '.btn-voir-plus',
			scrollThreshold: 600,
			status: '.page-load-status',
		});
	}
}
$(window).load(function(){
	if($(".woocommerce-shop").length){
		WooShop.init();
	}
	if($(".tax-product_cat").length){
		WooShop.init();
	}
	if($(".product-artiste-list").length){
		WooShop.init();
	}
	WooShop.load_more();
	if($(".single-product").length){
		WooShop.init();
	}
});